<template>
  <div class="ask-vote">
    <!-- 项目轮次 -->
    <div class="content-item">
      <div class="item-title ant-form-item-required">项目轮次：</div>
      <!-- <a-auto-complete
        :dataSource="roundList"
        :defaultActiveFirstOption="false"
        :filterOption="true"
        style="width: 200px"
        v-model="selectedRound"
        @change="selectRoundOrDecisionPoint"
        placeholder="请输入项目轮次"
      /> -->
      <stageSelect
        style="width: 200px"
        :type="1"
        :companyId="this.$route.query.id || this.$route.query.projectId"
        :value="roundValue"
        @input="getSelected"
      ></stageSelect>
    </div>
    <!-- 项目轮次 /-->
    <!-- 投资决策节点 -->
    <div class="content-item">
      <div class="item-title ant-form-item-required">投资决策节点：</div>
      <a-auto-complete
        :dataSource="decisionPointList"
        :defaultActiveFirstOption="false"
        :filterOption="true"
        style="width: 200px"
        v-model="selectedDecisionPoint"
        @change="selectRoundOrDecisionPoint"
        placeholder="请输入投资决策节点"
      />
    </div>
    <!-- 投资决策节点 /-->
    <!-- 本次投决名称 -->
    <div class="content-item">
      <div class="item-title ant-form-item-required">本次投决名称：</div>
      <a-input style="width: 300px" v-model="voteName" @change="changeVoteName" />
    </div>
    <!-- 关联会议开始 -->
    <div class="content-item">
      <div class="item-title">关联会议：</div>
      <a-select placeholder="请选择Vote发生时的关联会议" :defaultValue="currentMeetingId" style="width: 300px" @change="handleMeetingChange">
        <a-select-option key="init"> 请选择Vote发生时的关联会议 </a-select-option>
        <a-select-option :key="currentMeetingId" v-if="currentMeetingId">
          {{ currentMeetingName }}
        </a-select-option>
        <a-select-option v-for="meeting in meetingList" :key="meeting.id">
          {{ meeting.name }}
        </a-select-option>
      </a-select>
    </div>
    <!-- 关联会议结束 -->
    <!-- 本次投决名称 /-->
    <!-- 邀请参与者 -->
    <div class="content-item" style="align-items: flex-start">
      <div class="item-title ant-form-item-required">邀请参与者：</div>
      <div class="dealmembers">
        <select-member :width="350" :userlist="invitedPeople" @delChosenUser="delChosenUser" @chose="chooseInvitedPeople"></select-member>
      </div>
    </div>
    <!-- 邀请参与者 /-->
    <!-- 填写方式 -->
    <div class="content-item">
      <div class="item-title ant-form-item-required">填写方式：</div>
      <a-radio-group name="radioGroup" v-model="voteMode">
        <a-radio :value="1">创建人代填</a-radio>
        <a-radio :value="2">
          发送给参与者填写
          <div style="position: absolute; top: 24px; color: rgb(165, 162, 162)">(创建后会给参与者发通知)</div>
        </a-radio>
      </a-radio-group>
    </div>
    <!-- 填写方式 /-->
    <!-- Vote说明 -->
    <div class="content-item" v-if="+foldStatus === 2">
      <div class="item-title">Vote说明：</div>
      <a-textarea style="width: 300px; margin-top: 20px" v-model="voteIllustrate" />
    </div>
    <!-- Vote说明 -->
    <!-- 详细打分开始 -->

    <!-- 详细打分结束 -->
    <!-- 本次投决名称 /-->
    <div class="btn-group">
      <div v-if="+foldStatus === 1" style="color: #1892f7; cursor: pointer" @click="foldStatus = 2">
        展开
        <a-icon type="down" />
      </div>
      <div v-if="+foldStatus === 2" style="color: #1892f7; cursor: pointer" @click="foldStatus = 1">
        收起
        <a-icon type="up" />
      </div>
      <div class="btn" @click="cancelVote">取消</div>
      <div class="btn" @click="launchVote">
        <span v-if="voteId">保存</span>
        <span v-else>创建</span>
      </div>
    </div>
  </div>
</template>

<script>
import selectMember from '@/components/project/selectMember';
import { voteMangeInfo, askVote, voteMeetingList } from '@/api/projectVote';
import stageSelect from '@/components/base/stageSelect';

const phaseMap = {
  0: '发展期',
  1: '融资期'
};

export default {
  name: 'askVote',
  components: { selectMember, stageSelect },
  props: {
    voteId: {
      type: String,
      default() {
        return '';
      }
    },
    projectId: {
      type: String,
      default() {
        return null;
      }
    },
    currentMeetingId: {
      type: Number,
      default() {
        return null;
      }
    },
    currentMeetingName: {
      type: String,
      default() {
        return null;
      }
    },
    roundValue: {
      type: Object,
      default() {
        return {};
      }
    },
    historyStageMap: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      foldStatus: 1,
      decisionPointList: [],
      selectedDecisionPoint: '',
      voteName: '',
      manualChangeVoteName: false,
      invitedPeople: [],
      voteMode: 1,
      voteIllustrate: '',
      meetingList: [], //关联会议列表
      meetingId: '', //选中的会议
      // roundValue: {}
      phaseMap: phaseMap,
      selected: {}
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.selected = this.roundValue;
  },
  methods: {
    //关联会议的改变的回调
    handleMeetingChange(meetingId) {
      if (meetingId === 'init') {
        this.meetingId = '';
      } else {
        this.meetingId = meetingId.toString();
      }
    },
    async init() {
      if (this.voteId) {
        this.manualChangeVoteName = true;
      }
      voteMangeInfo({
        voteId: this.voteId
      }).then(res => {
        if (res.code === 200) {
          const data = res.data;
          this.invitedPeople = data.invitedPeople || [];
          this.decisionPointList = data.decisionPointList.map(item => item.name);
          if ((data.roundId || data.roundId === 0) && (data.phase || data.phase === 0)) {
            this.roundValue = {
              round: data.roundId,
              phase: data.phase
            };
          }
          if (this) this.selectedDecisionPoint = data.selectedDecisionPoint;
          this.voteIllustrate = data.voteIllustrate;
          this.voteName = data.voteName;
          if ((data.roundId || data.roundId === 0) && (data.phase || data.phase === 0)) {
            this.selected = { phase: data.phase, round: data.roundId };
          }
        }
      });

      const result = await voteMeetingList({ companyId: this.$route.query.id || this.$route.query.projectId });
      this.meetingList = result.data.list;
    },
    selectRoundOrDecisionPoint() {
      if (!this.manualChangeVoteName) {
        this.voteName = `${this.historyStageMap[this.selected.round] + '轮' + this.phaseMap[this.selected.phase] || ''}-${this.selectedDecisionPoint ||
          ''} 投资决策`;
      }
    },
    changeVoteName() {
      this.manualChangeVoteName = true;
    },
    chooseInvitedPeople(invitedPeople) {
      this.invitedPeople = invitedPeople;
    },
    validate() {
      if (!this.selectedDecisionPoint) {
        this.$message.error('请选择或填写投资决策节点');
        return false;
      }
      if (!this.voteName) {
        this.$message.error('请选择投资决策名称');
        return false;
      }
      if (!this.invitedPeople.length) {
        this.$message.error('请选投票参与者');
        return false;
      }
      if (!this.voteMode) {
        this.$message.error('请填写填写方式');
        return false;
      }
      return true;
    },
    launchVote() {
      if (this.validate()) {
        let voteBody = {
          meetingId: this.meetingId,
          projectId: this.projectId,
          voteId: this.voteId,
          // selectedRound: this.selectedRound,
          selectedDecisionPoint: this.selectedDecisionPoint,
          invitedPeople: this.invitedPeople.map(item => item.id).join(','),
          voteMode: this.voteMode,
          voteName: this.voteName,
          voteIllustrate: this.voteIllustrate,
          roundId: this.selected.round,
          phase: this.selected.phase
        };
        if (!this.meetingId) {
          delete voteBody.meetingId;
        }
        askVote(voteBody).then(res => {
          if (res.code === 200) {
            this.$emit('launchVote');
          }
        });
      }
    },
    cancelVote() {
      this.$emit('cancelVote');
    },
    delChosenUser(user) {
      this.invitedPeople = this.invitedPeople.filter(_user => +_user.id !== +user.id);
    },
    getSelected(val) {
      this.selected = val;
    }
  }
};
</script>

<style lang="less" scoped>
.ask-vote {
  .content-item {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    .item-title {
      width: 140px;
      text-align: right;
    }
    .dealmembers {
      display: flex;
      align-items: center;
      width: 350px;
      flex-wrap: wrap;
    }
  }
  .btn-group {
    margin-top: 40px;
    display: flex;
    justify-content: flex-end;
    user-select: none;
    cursor: pointer;
    .btn {
      cursor: pointer;
      margin: 20px 0 0 20px;
      float: right;
      background: #1892f7;
      color: #fff;
      padding: 2px 4px;
      width: 80px;
      text-align: center;
      border-radius: 4px;
    }
  }
}
</style>
